/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Go_To_Start_TitleInputs */



/**
* | output |
* | --- |
* | "Go To Start" |
*
* @param {Player_Go_To_Start_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_go_to_start_title = /** @type {((inputs?: Player_Go_To_Start_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Go_To_Start_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller au Debut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum Start")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai all'inizio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к началу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir al inicio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("返回开头")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタートへ戻る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शुरुआत पर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ir para o início")
	return /** @type {LocalizedString} */ ("Go To Start")
});